<div class="fd-admin-backdrop" *ngIf="visible$">
	<div class="fd-admin-dialog" role="dialog" aria-modal="true" aria-label="Freshdesk admin">

		<div class="fd-admin-content">

			<!-- HEADER -->
			<div class="fd-admin-header">
				<div class="header-left">
					<div class="title">{{ title }}</div>
					<div class="subtitle" *ngIf="articles?.length">
						{{ articles.length }} linked article{{ articles.length === 1 ? '' : 's' }}
					</div>
				</div>

				<div class="header-right">
					<button type="button" class="icon-btn" (click)="close()" aria-label="Close">✕</button>
				</div>
			</div>

			<!-- BODY -->
			<div class="fd-admin-body">

				<!-- TOOLBAR (sticky) -->
				<div class="fd-toolbar">
					<form class="add-row" [formGroup]="addForm" (ngSubmit)="addEntry()" novalidate>
						<div class="field">
							<label class="label" for="articleId">Freshdesk Article ID</label>
							<input type="text" id="articleId" class="input" formControlName="articleId" inputmode="numeric" placeholder="e.g. 123456789" />
							<div *ngIf="addForm.controls.articleId.invalid && addForm.controls.articleId.touched" class="error">
								Please enter a valid numeric article ID.
							</div>
						</div>

						<div class="actions">
							<button type="submit" class="btn-primary" [disabled]="addForm.invalid || loading">
								<span *ngIf="loading" class="spinner" aria-hidden="true"></span>
								{{ loading ? 'Adding…' : 'Add article' }}
							</button>

							<button type="button" class="btn-ghost" (click)="refreshArticles()">
								Refresh
							</button>
						</div>
					</form>

					<div class="hint">
						Drag rows using the handle to reorder. Changes are saved automatically.
					</div>
				</div>

				<!-- GRID -->
				<div class="grid-shell">
					<dx-data-grid [dataSource]="articles" [showBorders]="false" [columnAutoWidth]="true" [rowAlternationEnabled]="true" [hoverStateEnabled]="true" height="100%">
						<dxo-row-dragging [allowReordering]="true" [showDragIcons]="true" [onReorder]="onReorder"></dxo-row-dragging>

						<dxi-column dataField="index" caption="#" [width]="70"></dxi-column>
						<dxi-column dataField="articleId" caption="Article ID" [width]="120"></dxi-column>
						<dxi-column dataField="title" caption="Title"></dxi-column>
						<dxi-column dataField="articleCreatedAt" caption="Created" dataType="datetime" [width]="170"></dxi-column>
						<dxi-column dataField="articleEditedAt" caption="Modified" dataType="datetime" [width]="170"></dxi-column>

						<dxi-column [width]="56" [allowFiltering]="false" [allowSorting]="false" cellTemplate="deleteTpl"></dxi-column>

						<div *dxTemplate="let data of 'deleteTpl'">
							<button type="button" class="trash-btn" (click)="deleteEntry(data)" aria-label="Delete">
								<i class="far fa-fw fa-trash-alt"></i>
							</button>
						</div>
					</dx-data-grid>
				</div>

				<!-- FOOTER -->
				<div class="fd-admin-footer">
					<button type="button" class="btn-ghost" (click)="close()">Close</button>
				</div>

			</div>
		</div>
	</div>
</div>
